import { useLocation } from 'react-router-dom';

import { useInsertReportingAnalyticsMutation } from "../queries";
import { AnalyticsPayload, ANALYTICS_TAB_NAME } from './constants';

const useReportingAnalytics = () => {
    const { pathname } = useLocation();

    const { mutate: insertAnalyticsMutation } = useInsertReportingAnalyticsMutation();

    const handleInsertAnalytics = (payload: AnalyticsPayload) => {
        insertAnalyticsMutation({ tab_name: ANALYTICS_TAB_NAME[pathname], ...payload })
    }

    return { handleInsertAnalytics }
}

export default useReportingAnalytics